module.exports = __webpack_public_path__ + "static/media/shards-dashboards-logo.d1f43f31.svg";